import { EVENT_TYPES, EVENT_INTERVALS } from './constants';

export const routerPath = {
    root: '/oakley-events',
    link: '/general/oakley-events',
};

export const TABLE_HEAD = [
    { id: 'name', label: 'Name', align: 'left' },
    { id: 'type', label: 'Type', align: 'left' },
    { id: 'interval', label: 'Interval', align: 'left' },
    { id: 'startDay', label: 'Start Day', align: 'left' },
    { id: 'time', label: 'Time', align: 'left' },
    { id: 'active', label: 'Status', align: 'left' },
    { id: 'actions', label: 'Actions', align: 'right' },
];

export const defaultValues = {
    name: '',
    description: '',
    type: '',
    interval: '',
    weeklyStartDay: '',
    monthlyStartDay: '',
    singleEventDate: '',
    address: '',
    latitude: '',
    longitude: '',
    listImageId: '',
    detailsImageId: '',
    mapIconId: '',
    instagram: '',
    adultPaymentLink: '',
    childPaymentLink: '',
    time: '',
    active: true,
};

export const getColumns = ({ deleteItem, editItem }) => {
    const menuItems = [
        { id: 1, name: 'Edit', action: editItem, icon: 'eva:edit-fill' },
        {
            id: 2,
            name: 'Delete',
            action: deleteItem,
            icon: 'eva:trash-2-outline',
            sx: { color: 'error.main' },
        },
    ];

    return [
        { id: 'name', label: 'Name', align: 'left', nameForSort: 'name' },
        {
            id: 'type',
            label: 'Type',
            align: 'center',
            nameForSort: 'type',
            customValue: (val) => val.type.charAt(0).toUpperCase() + val.type.slice(1),
        },
        {
            id: 'interval',
            label: 'Interval',
            align: 'center',
            nameForSort: 'interval',
            customValue: (val) => val.interval.charAt(0).toUpperCase() + val.interval.slice(1),
        },
        {
            id: 'startDay',
            label: 'Start Day',
            align: 'center',
            nameForSort: 'start_day',
            customValue: (val) => {
                if (val.interval === EVENT_INTERVALS.WEEKLY) return val.weeklyStartDay;
                if (val.interval === EVENT_INTERVALS.MONTHLY) return val.monthlyStartDay;
                if (val.interval === EVENT_INTERVALS.SINGLE) {
                    const dateStr = val.single_start_date || val.singleEventDate;
                    return dateStr ? new Date(dateStr).toLocaleDateString() : '';
                }
                return '';
            },
        },
        {
            id: 'time',
            label: 'Time',
            align: 'center',
            nameForSort: 'time',
        },
        {
            id: 'active',
            label: 'Status',
            align: 'center',
            customValue: (val) => (val.active ? 'Active' : 'Inactive'),
            nameForSort: 'active',
        },
        {
            id: 'more-menu',
            type: 'menu',
            items: menuItems,
            disableSort: true,
        },
    ];
};

export const getFilters = ({ searchBy, eventType, interval, active }) => [
    {
        id: 'name',
        type: 'search',
        placeholder: 'Event name',
        defaultValue: searchBy.defaultValue,
        action: searchBy.change,
    },
    {
        id: 'eventType',
        type: 'select',
        label: 'Type',
        value: eventType.value,
        action: eventType.change,
        items: ['all', ...Object.values(EVENT_TYPES)],
    },
    {
        id: 'interval',
        type: 'select',
        label: 'Interval',
        value: interval.value,
        action: interval.change,
        items: ['all', ...Object.values(EVENT_INTERVALS)],
    },
    {
        id: 'active',
        type: 'switch',
        label: 'Include Inactive',
        value: active.value === 'true',
        action: (val) => active.change(String(val)),
    },
];
